'use client';

import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  width: 100%;
  border-radius: 10px;
  background-color: #f2f2f2;
  overflow: hidden;
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  cursor: pointer;
`;

const StatusBadge = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 62px;
  height: 30px;
  border: 1px solid ${({ theme }) => theme.rootColor.white};
  border-radius: 100px;
  color: ${({ theme }) => theme.rootColor.white};
  font-size: 14px;
  font-weight: 700;
  z-index: 1;
`;

const LikeButtonWrapper = styled.div`
  position: absolute;
  right: 13px;
  bottom: 13px;
  z-index: 1;

  & > button {
    filter: drop-shadow(0px 0px 8px rgba(255, 255, 255, 0.25));
  }
`;

const OriginalsCardStyled = {
  Container,
  ImageWrapper,
  StatusBadge,
  LikeButtonWrapper,
};

export default OriginalsCardStyled;
